module.exports = __webpack_public_path__ + "img/d5x16_gb119.prt.d18086dd.jpg";